import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import { useDocumentHead } from "@/hooks/useDocumentHead";

export default function NotFound() {
  const location = useLocation();

  useDocumentHead({
    title: "Page introuvable (404) — Gwada Nuisibles",
    description: "",
    noindex: true,
  });

  return (
    <main>
      <Header />
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-4 py-20 bg-background-50">
        <h1 className="font-heading font-black text-6xl md:text-8xl text-primary-500 mb-4">404</h1>
        <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-3">
          Page introuvable
        </h2>
        <p className="text-foreground-500 text-base mb-2">
          La page que vous cherchez n&rsquo;existe pas ou a été déplacée.
        </p>
        <p className="text-foreground-400 text-sm font-mono mb-8">{location.pathname}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-secondary-500 font-semibold hover:text-secondary-600 transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
          Retour à l&rsquo;accueil
        </Link>
      </div>
      <Footer />
      <FloatingWhatsApp />
    </main>
  );
}